import { render } from "./box.vue?vue&type=template&id=430101d1"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/box.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "430101d1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('430101d1', __exports__)) {
    api.reload('430101d1', __exports__)
  }
  
  module.hot.accept("./box.vue?vue&type=template&id=430101d1", () => {
    api.rerender('430101d1', render)
  })

}


export default __exports__